import $ from "jquery";
import Cookies from "js-cookie";

const $cookiesEl = $(".cookies");
const $cookiesBar = $(".cookies__bar");
const cookiesModal = $("#cookies-modal");
const $cookiesConsent = $(".cookies-consent, .cookies-check-all");
const $cookiesConsentCustom = $(".cookies-consent-custom");
const $cookiesDecline = $(".cookies-decline");
const $checkboxes = $cookiesEl.find(".cookies__checkbox");

const cookiesExpiration = 120;

const acknowledgeCookies = (type = "custom") => {
  let categories = [];

  switch (type) {
    case "all":
      checkAll();
      break;
    case "required":
      checkRequired();
      break;
    case "custom":
      break;
  }

  $checkboxes
    .filter(function () {
      return $(this).is(":checked");
    })
    .each(function () {
      categories.push($(this).data("category"));
    });

  categories = categories.join(",");

  const cookie_cnsnt = Cookies.get("cookie_cnsnt");

  if (cookie_cnsnt === undefined || cookie_cnsnt != categories) {
    Cookies.set("cookie_cnsnt", categories, { expires: cookiesExpiration });
    initCookieFunctions();
  }
};

const initCookieFunctions = () => {
  const cookie_cnsnt = Cookies.get("cookie_cnsnt");

  if (cookie_cnsnt !== undefined) {
    if (SITE_PARAMS.user_is_admin) {
      console.log("Cookie init..." + cookie_cnsnt);
    }
    const categories = cookie_cnsnt.split(",");

    initGoogleAnalytics(
      categories.includes("analytics") ? "granted" : "denied"
    );
  }
};

const initGoogleAnalytics = (mode = "denied") => {
  if (SITE_PARAMS.user_is_admin) {
    console.log("GA " + mode + "...");
  }
  // gtag("consent", "update", {
  //   analytics_storage: mode,
  // });
};

const checkAll = () =>
  $checkboxes
    .filter(function () {
      return !$(this).is(":disabled");
    })
    .prop("checked", true);

const checkRequired = () =>
  $checkboxes
    .filter(function () {
      return !$(this).is(":disabled");
    })
    .prop("checked", false);

const checkSelected = (categories) =>
  $checkboxes
    .filter(function () {
      return !$(this).is(":disabled");
    })
    .each(function () {
      const $thisEl = $(this);
      $thisEl.prop("checked", categories.includes($thisEl.data("category")));
    });

Cookies.get("cookie_cnsnt") === undefined
  ? $cookiesBar.slideUp(0).slideDown(300).addClass("cookies__bar--active")
  : initCookieFunctions();

$cookiesConsent.on("click", () => {
  acknowledgeCookies("all");
  $cookiesBar.removeClass("cookies__bar--active").slideUp(300);
});
$cookiesDecline.on("click", () => {
  acknowledgeCookies("required");
  $cookiesBar.removeClass("cookies__bar--active").slideUp(300);
});
$cookiesConsentCustom.on("click", () => {
  acknowledgeCookies();
  $cookiesBar.removeClass("cookies__bar--active").slideUp(300);
});

cookiesModal.on("modal:opening modal:closing", () => {
  const cookie_cnsnt = Cookies.get("cookie_cnsnt");

  if (cookie_cnsnt !== undefined) {
    const categories = cookie_cnsnt.split(",");
    checkSelected(categories);
  } else {
    checkRequired();
  }
});
